export default "__VITE_ASSET__EGOs73qR__"